import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen w-full bg-ivory font-sans text-ink selection:bg-gold selection:text-ink" data-id="element-0" data-mp="2mlubatj25zve">
      <Navbar data-id="element-1" data-mp="31agoopp4khjz" />
      <main data-id="element-2" data-mp="31ayr642drs0c">
        <Hero data-id="element-3" data-mp="31brzvakwgrl4" />
        <PainPoints data-id="element-4" data-mp="31c9ts0k3atpv" />
        <Services data-id="element-5" data-mp="31ctetq51dy84" />
        <Team data-id="element-6" data-mp="2wk06ksad07ra" />
        <Testimonials data-id="element-7" data-mp="2wjgpfdsj9neb" />
        <FinalCTA data-id="element-8" data-mp="2wj8cxn0bok3n" />
      </main>
      <Footer data-id="element-9" data-mp="2whx95n6vnccj" />
      <WhatsAppButton data-id="element-10" data-mp="28ufpkexrnkkn" />
    </div>;
}